export default "__VITE_ASSET__CuEyVkJI__"